import {forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal, Popover, Select, Tag} from "antd";
import {t} from "i18next";
import {
    formatDateCharDesc, generateUUID2,
    getImagePathWithTheme,
    getImagePathWithThemeSvg,
    isDarkMode, isNumberOrFloat,
    isStringNullOrEmpty, stringToDate, stringToDateOrNull
} from "../../utils";
import {
    ARRAY_PROPERTY_OPTIONS_COLOR,
    getDefaultTagBackgroundColor,
    getPropertySelectOptionBackgroundColor,
    IMPORT_FILE_MODE_IMPORTMODE
} from "../../Const";
import {ipcInvoke} from "../../common/ipc";
import PopupDate from "@/views/Property/PopupDate";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import { useSortable } from "@dnd-kit/sortable";
import {getPropertyById, updateProperty} from "@model/Property";

const DialogBatchUpdateProperty = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const mOptionData = useRef(null);
    const [customInputTextInfo,setCustomInputTextInfo] = useState<any>({});
    const [checkboxValue,setCheckboxValue] = useState(false);
    const [arraySelectItems,setArraySelectItems] = useState([]);
    const [inputDate,setInputDate] = useState('');
    const [inputText,setInputText] = useState('');
    const [openDatePicker,setOpenDatePicker] = useState(false);
    const [arraySelectInfo,setArraySelectInfo] = useState([]);
    const [mapIsSelectHovered,setMapIsSelectHovered] = useState<any>({});
    const [randomKey,setRandomKey] = useState(generateUUID2());

    const txtInputRef = useRef(null);
    const mCallback = useRef<any>(null);
    const mArraySelectInfoRef = useRef([]);
    const mArraySelectItemsRef = useRef([]);

    useEffect(() => {
        mArraySelectInfoRef.current = arraySelectInfo;
    }, [arraySelectInfo]);

    useEffect(() => {
        mArraySelectItemsRef.current = arraySelectItems;
    }, [arraySelectItems]);

    const onShowDialog = (optionData:any,callback:any)=>{
        setIsShowDialog(true);
        mOptionData.current = optionData;
        mCallback.current = callback;
        const szType = mOptionData.current?.type;
        if (szType == 'select' || szType == 'multiSelect') {
            getPropertyById(optionData.id).then(res=>{
                setArraySelectItems(res.items);
            })
        }else if (szType == 'date'){
            setInputDate('');
        }else{
            setInputDate('');
        }

        setInputText('');
        setCheckboxValue(false);
        setCustomInputTextInfo({});
        setArraySelectInfo([]);

        setTimeout(()=>{
            txtInputRef.current?.focus();
        },100)
    }

    /**
     * 标题
     */
    const getTitle = ()=>{
        const szType = mOptionData.current?.type;
        if (szType == 'rating'){
            return t('Update rating')
        }else if (szType == 'text' || szType == 'number'){
            return t('Update text')
        }else if (szType == 'url'){
            return t('Update URL')
        }else if (szType == 'number'){
            return t('Update number')
        }
        else if (szType == 'checkbox'){
            return t('Update checkbox')
        }else if (szType == 'select' || szType == 'multiSelect'){
            return t("Update select")
        }else if (szType == 'date'){
            return t('Update date');
        }
        return '';
    }

    /**
     * 更新条目----
     * @param row
     */
    const updateItem = (row)=>{
        // if (row.original.type == 'project') {
        //     return updateProject(row.original);
        // } else {
        //     return updateCard(row.original);
        // }
    }

    /**
     * 更新属性...
     * @param newTag
     */
    const onUpdateProperty = (newTag)=>{
        const arrayNewSelect = [...mArraySelectItemsRef.current]
        const nIndex = arrayNewSelect.findIndex(p=>p.id == newTag.id);
        if (nIndex != -1){
            arrayNewSelect.splice(nIndex,1,newTag);
        }
        setArraySelectItems(arrayNewSelect);
        setRandomKey(generateUUID2());
        //更新到数据库.
        getPropertyById(mOptionData.current?.id).then(res=>{
            res.items = arrayNewSelect;
            updateProperty(res).then(rrr=>{
                if (window['refresh_tableview_']){
                    window['refresh_tableview_']();
                }
            });
        })
    }

    /**
     * 更多菜单
     */
    const renderMore = (option) => {
        // const [inputValue,setInputValue] = useState(option.text);//这里面不能这种声明。
        return <div className={'flex-col'} onMouseDown={(e) => {
            e.stopPropagation();
        }} onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
        }}>
            <input id={`txt-table-view-select-${option.id}`} className={'input-border input-border-focus'}
                   autoFocus={true}
                   defaultValue={option.text}  onBlur={(e) => {
                if (e.currentTarget.value) {
                    //判断是否已经有这个名称了。。。
                    const hasExist = arraySelectItems.some(p => p.text.toLowerCase() == e.currentTarget.value.toLowerCase() && p.id != option.id);
                    if (hasExist) {
                        message.error(t('DataExists'));
                    } else {
                        const newTag = {...option, text: e.currentTarget.value}
                        onUpdateProperty(newTag);
                    }
                }
            }} onInput={(e) => {
                // setInputValue(e.currentTarget.value);
            }} onKeyDown={(e) => {
                if (e.key == KEYS.ENTER) {
                    const txt = document.getElementById(`txt-table-view-select-${option.id}`);
                    txt?.blur();
                }
            }}/>
            <div className={'flex-row-vertical-center cursor-pointer hovered-gray-radius-3'}
                 style={{height: '32px', margin: '8px -12px 0px -12px'}} onClick={(e) => {
                window.showMessageBox(t("Delete option"), t("SureToDeleteOption"), t("Cancel"), t("Delete"), null, () => {
                    //删除
                    const newTag = {...option, text: null};
                    const arrayNewSelect = [...arraySelectInfo];
                    const nIndex = arrayNewSelect.findIndex(p => p.id == newTag.id);
                    if (nIndex != -1) {
                        arrayNewSelect.splice(nIndex, 1);
                        setArraySelectInfo(arrayNewSelect);
                        // 保存到数据.
                        // row.original[cell.column.id] = arrayNewSelect;
                        // //保存到数据库..
                        // updateItem(row);
                    }

                    //从所有cell中移除这个列表...
                    // for (let i=0;i<tableData.columns.length;i++){
                    //     if (column.items){
                    //         const nIndex = column.items.findIndex(p=>p.id == newTag.id);
                    //         if (nIndex != -1){
                    //             column.items.splice(nIndex,1);
                    //         }
                    //     }
                    // }
                    //从所有cell数据中移除这个..
                    // const newTableData:any = {...mTableviewDataRef.current};
                    // const arrayDatas = [];
                    // for (let i=0;i<newTableData.data.length;i++){
                    //     const data = newTableData.data[i];
                    //     const arraySelect = data[cell.column.id];
                    //     if (isArray(arraySelect)){
                    //         //删除这个...
                    //         const nIndex = arraySelect.findIndex(p=>p.id == newTag.id);
                    //         if (nIndex != -1){
                    //             arraySelect.splice(nIndex,1);
                    //         }
                    //     }
                    //     arrayDatas.push(data);
                    // }
                    // newTableData.data = arrayDatas;
                    // setTableData(newTableData);
                })
            }}>
                <img className={'img-16 ml-20'} src={getImagePathWithThemeSvg('option_delete')}/>
                <span className={'ml-8'}>{t('Delete option')}</span>
            </div>
            <div className={'line mt-12'} style={{margin: '8px -12px'}}></div>
            <div className={'mt-2'} style={{
                display: 'grid',
                padding: '0 8px',
                gap: '12px 0',
                gridTemplateColumns: 'repeat(4,auto)',
                justifyContent: 'space-between'
            }}>
                {
                    ARRAY_PROPERTY_OPTIONS_COLOR.map(p => {
                        return <div className={'cursor-pointer'} style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '8px',
                            background: `${isDarkMode()?p.useDarkColor:p.color}`
                        }}  onMouseDown={(e) => {
                            e.stopPropagation();
                            setTimeout(()=>{
                                const newTag = {...option, backgroundColor: p.usedColor};
                                onUpdateProperty(newTag);
                            },100)
                        }}>
                        </div>
                    })
                }
            </div>

        </div>
    }

    const tagRender: any = useCallback((props) => {
        const ttttaaaagggggg = mArraySelectItemsRef.current.find(p => p.id == props.value);
        return (
            <Tag
                closable={props.closable}
                onClose={(e) => {
                    const arrayNewSelect = [...mArraySelectInfoRef.current];
                    const nIndex = arrayNewSelect.findIndex(p => p.id == props.value);
                    arrayNewSelect.splice(nIndex, 1);
                    setArraySelectInfo(arrayNewSelect);
                }}
                className={'tableview-tag default-font-size'}
                style={{
                    backgroundColor: getPropertySelectOptionBackgroundColor(ttttaaaagggggg?.backgroundColor),
                    marginLeft: '0px',
                    color:'var(--text-color)'
                }}
            >
                {ttttaaaagggggg?.text}
            </Tag>
        );
    }, []);


    /**
     * 渲染内容
     */
    const renderContent = ()=>{
        const szType = mOptionData.current?.type;
        if (szType == 'rating'){
            return <div className={'flex-center tableview-column-style'}
                        style={{
                            height: '100%',
                            position: 'relative',
                            gap: '0 30px'
                        }}>
                {
                    [...Array(5)].map((p, index) => {
                        return <img className={'img-24 cursor-pointer'}
                                    src={getImagePathWithThemeSvg(`column_rate${index < customInputTextInfo?.text ? '_selected' : ''}`)}
                                    onClick={(e) => {
                                        let szInput = index+1;
                                        const newInputValue = {...customInputTextInfo};
                                        if (newInputValue.text == szInput) {
                                            szInput = 0;
                                        }
                                        newInputValue.text = szInput;
                                        newInputValue.type = 'rating';
                                        setCustomInputTextInfo(newInputValue);
                                    }}/>
                    })
                }
            </div>
        }else if (szType == 'text' || szType == 'number' || szType == 'url'){
            return <div className={'flex-row-vertical-center cursor-pointer'} style={{height: '100%',margin:'0 26px'}}>
                <textarea autoFocus={true} ref={txtInputRef} value={inputText} className={'input-border'} placeholder={t('Enter')} style={{resize:'none',height:'130px',width:'100%',padding:'6px 10px',color:'var(--text-color)'}} onChange={(e)=>{
                    if (mOptionData.current?.type == 'number'){
                        if (isNumberOrFloat(e.currentTarget.value) || !e.currentTarget.value){
                            setInputText(e.currentTarget.value);
                        }
                    }else {
                        setInputText(e.currentTarget.value);
                    }
                }}/>
            </div>
        }else if (szType == 'date'){
            return <div className={'flex-row-vertical-center cursor-pointer'}
                        style={{margin: '22px 26px'}}>
                <Popover arrow={false} align={{}} trigger={['click']}
                         open={openDatePicker}
                         onOpenChange={(e)=>setOpenDatePicker(e)}
                         placement={'bottomLeft'}
                         content={<PopupDate defaultDate={customInputTextInfo?.text}
                                             width={'334px'}
                                             from={'batchUpdateProperty'}
                                             onDateSelect={(longDate, hasClose = true) => {
                                                 const newInputValue = {...customInputTextInfo};
                                                 newInputValue.text = longDate;
                                                 newInputValue.type = 'date';
                                                 setCustomInputTextInfo(newInputValue);
                                                 //输入的变为当前日期..
                                                 setInputDate(formatDateCharDesc(longDate));
                                                 setOpenDatePicker(false);
                                             }}/>}>
                    <input ref={txtInputRef} value={inputDate} className={'input-border'} style={{width: '100%'}} onChange={(e)=>{
                        setInputDate(e.currentTarget.value);
                    }}/>
                </Popover>

            </div>
        } else if (szType == 'checkbox') {
            return <div className={'flex-row-vertical-center cursor-pointer'} style={{height: '100%',marginLeft:'26px'}} onClick={(e)=>{
                setCheckboxValue(!checkboxValue);
            }}>
                <Checkbox checked={checkboxValue}/>
                <span className={'ml-6'}>{checkboxValue?t('Checked'):t('Unchecked')}</span>
            </div>
        }else if (szType == 'select' || szType == 'multiSelect') {
            const getSelectText = () => {
                const arrayTxt = [];
                for (let i = 0; i < arraySelectInfo?.length; i++) {
                    arrayTxt.push(arraySelectInfo[i].id);
                }
                return arrayTxt;
            }

            //是多选吗？
            const isMultipSelect = () => {
                return mOptionData.current?.type == 'multiSelect'
            }

            return <div style={{margin: '26px 26px'}}>
                <Select
                    key={randomKey}
                autoFocus={true}
                mode={"tags"}
                open={false}
                suffixIcon={null}
                tagRender={tagRender}
                value={getSelectText()}
                options={arraySelectItems}
                className={'fix-gab-select-custom-height-center'}
                style={{
                    padding: '0 6px',
                    background: isDarkMode()?'#444444':'#F4F4F6',
                    borderRadius: '8px 8px 0 0',
                    height: '36px',
                    lineHeight: '36px',
                    width:'100%'
                }}
                variant={"borderless"}
                onSearch={(e) => {
                    const szValue = e.toLowerCase();
                    const arrayNewOptions: any = [];
                    for (let i = 0; i < mOptionData.current?.items?.length; i++) {
                        const item = mOptionData.current?.items[i];
                        if (item.text.toLowerCase().includes(szValue)) {
                            arrayNewOptions.push(item);
                        }
                    }
                    if (arrayNewOptions.length == 0) {
                        //创建一个新的----
                        arrayNewOptions.push({
                            id: generateUUID2(),
                            text: e,
                            isNew: true,
                            sort: 0
                        })
                    }
                    setArraySelectItems(arrayNewOptions);
                }}

                placeholder={t('SearchForAnOption')}
                dropdownClassName={''}
                dropdownStyle={{border: '1px solid var(--border-color)', borderRadius: '0 0 8px 8px',}}
            />
                <div className={'flex-col'} style={{marginTop: '0px',border: '1px solid var(--border-color)', borderRadius: '0 0 8px 8px',height:'120px',overflow:'auto'}}>
                    {
                        // <div>0000</div>
                        arraySelectItems?.map(p => {
                            return <div data-id={p.id}
                                        className={'flex-row-vertical-center cursor-pointer hovered-gray-radius-3'}
                                        style={{padding: '4px 8px',}}
                                        onMouseDown={(e) => {
                                            e.stopPropagation();
                                        }} onClick={async (e) => {
                                e.stopPropagation();
                                if (arraySelectInfo.some(pp => pp.id == p.id)) {
                                    //已经有了，返回.
                                    return;
                                }

                                if (p.isNew) {
                                    //保存到这个自定义属性下的select 中去...
                                    const property = await getPropertyById(mOptionData.current?.id);
                                    if (!property.items) {
                                        property.items = [];
                                    }
                                    delete p.isNew;
                                    property.items.push(p);
                                    await updateProperty(property);

                                    //加到数据里面....
                                    mOptionData.current.items.push(p);
                                    //恢复原集合.
                                    setArraySelectItems(mOptionData.current.items);
                                }

                                let arrayNewSelect: any = [...arraySelectInfo];
                                if (!isMultipSelect()) {
                                    arrayNewSelect = [];
                                }
                                arrayNewSelect.push(p);
                                setArraySelectInfo(arrayNewSelect);

                                // row.original[cell.column.id] = arrayNewSelect
                                // //保存这个属性...
                                // updateItem(row);

                                //添加到数据集合.
                            }} onMouseEnter={(e) => {
                                // const arrayNewSelect = [...arraySelectItems];
                                // arrayNewSelect.forEach(p => p.isHovered = false);
                                // p.isHovered = true;
                                // setArraySelectItems(arrayNewSelect);
                                const newMap = {...mapIsSelectHovered};
                                const arrayKeys = Object.keys(newMap);
                                arrayKeys.forEach(pp=>{
                                    newMap[pp] = false;
                                })
                                newMap[p.id] = true;
                                setMapIsSelectHovered(newMap);
                            }} onMouseLeave={(e) => {
                                // const arrayNewSelect = [...arraySelectItems];
                                // arrayNewSelect.forEach(p => p.isHovered = false);
                                // setArraySelectItems(arrayNewSelect);
                                const newMap = {...mapIsSelectHovered};
                                const arrayKeys = Object.keys(newMap);
                                arrayKeys.forEach(pp=>{
                                    newMap[pp] = false;
                                })
                                setMapIsSelectHovered(newMap);
                            }}>
                                <div>
                                    {
                                        p.isNew &&
                                        <label
                                            style={{marginRight: '8px'}}>{t('Create')}</label>
                                    }
                                    <label className={'tableview-tag cursor-pointer'}
                                           style={{
                                               background: getPropertySelectOptionBackgroundColor(p.backgroundColor),
                                               display: 'inline-block',
                                               borderRadius: '4px',
                                           }}>{p.text}</label>
                                </div>
                                {
                                    <Popover trigger={['click']} content={renderMore(p)}
                                             arrow={false}
                                             overlayInnerStyle={{width: '200px'}}
                                             placement={'rightTop'}
                                             afterOpenChange={(e) => {
                                                 if (e) {
                                                     setTimeout(() => {
                                                         const txt = document.getElementById(`txt-table-view-select-${p.id}`);
                                                         if (txt) {
                                                             txt.focus();
                                                         }
                                                     }, 20)
                                                 }
                                             }}>
                                        <div className={'flex-center'} style={{
                                            width: '22px',
                                            height: '22px',
                                            marginLeft: 'auto'
                                        }} onMouseDown={(e) => {
                                            e.stopPropagation();
                                        }} onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                        }}>
                                            {
                                                !p.isNew && mapIsSelectHovered[p.id] &&
                                                <img style={{}}
                                                     className={'img-12 cursor-pointer mr-10'}
                                                     src={getImagePathWithTheme('note_card_h_more')}
                                                />
                                            }

                                        </div>

                                    </Popover>
                                }

                            </div>
                        })
                    }
                </div>
            </div>
        }

        return <></>
    }

    return <Modal width={460} zIndex={2005} bodyStyle={{height: `${260}px`}}
                  afterClose={() => {
                      if (props.onCloseCallback) {
                          props.onCloseCallback();
                      }
                  }}
                  destroyOnClose={true}
                  open={isShowDialog} centered={true} closable={false} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title'}>{getTitle()}</span>
                {/*<div style={{flexGrow: '1'}}/>*/}
            </div>
            {/*<div className={'line mt-12'} style={{margin: '12px -22px'}}></div>*/}

            {renderContent()}

            <div className={'flex-center mb-4'} style={{marginTop: 'auto',flexShrink:'0'}}>
                <Button
                    style={{height: '34px', minWidth: '160px'}}
                    className='large-w-button button-border-gray-style font-size-14 font-family-medium'
                    onClick={() => {
                        setIsShowDialog(false);
                    }}>{t("Cancel")}</Button>
                <Button
                    // disabled={isStringNullOrEmpty(selectFile)}
                    className='large-w-button button-solid-style font-size-14 font-family-medium'
                    type="primary"
                    onClick={async () => {
                        if (mCallback.current) {
                            const szType = mOptionData.current?.type;
                            if (szType == 'rating' || szType == 'date') {
                                if (szType == 'date' && !inputDate) {
                                    //加一个检测日期.
                                    const date = stringToDateOrNull(inputDate);
                                    if (!date) {
                                        message.error(t('DateError'));
                                        return;
                                    }
                                }
                                mCallback.current(szType, customInputTextInfo.text)
                            } else if (szType == 'text' || szType == 'number' || szType == 'url') {
                                mCallback.current(szType, txtInputRef.current?.value)
                            } else if (szType == 'checkbox') {
                                mCallback.current(szType, checkboxValue)
                            } else if (szType == 'select' || szType == 'multiSelect') {
                                mCallback.current(szType, mArraySelectInfoRef.current)
                            } else if (szType == 'date') {
                                mCallback.current(szType, inputDate)
                            }
                        }
                        setIsShowDialog(false);
                    }}
                    style={{
                        marginLeft: '40px',
                        minWidth: '160px'
                    }}
                    htmlType={"submit"}>{t("Update1")}</Button>
            </div>
        </div>
    </Modal>
})

export default DialogBatchUpdateProperty;






















